import {
  mapTemplatesAdi,
  defaultInstaIds,
} from '../templates/templatesConfig.json';
import defaultDemoAccount from '../templates/defaultDemoAccount.json';
import defaultDemoAccountEditorX from '../templates/defaultDemoAccountEditorX.json';
import WixService from './WixService';
import { ERRORS } from '../../constants';
import {
  getInstagramMedias,
  getTemplateMedias,
  getTemplateUser,
  getInstagramUser,
} from '../api/instagramApi';
import { buildError } from '../more/utils';
import store from '../../store';
import triggerEvent from './biEditorLogger';
import biData from '../../bi/editorEvents.json';

const compId = WixService.getCompId();
const origInstanceId = WixService.getOrigInstaceId();

function _getInstagramData() {
  const { userDBData } = store.getState().appReducer;
  if (
    userDBData &&
    userDBData.insta_user_id &&
    userDBData.insta_user_id !== 'null'
  )
    return new Promise((resolve) => {
      resolve(userDBData);
    });
  const key = `settings${compId}`;
  return WixService.getDataPublic(key)
    .then((dataPublicSettings) => {
      dataPublicSettings[key]['origInstanceId'] = origInstanceId;
      dataPublicSettings[key]['in_u_id'] =
        !dataPublicSettings[key]['in_u_id'] &&
        origInstanceId &&
        mapTemplatesAdi[origInstanceId]
          ? mapTemplatesAdi[origInstanceId]
          : dataPublicSettings[key]['in_u_id'];
      return dataPublicSettings[key];
    })
    .catch((e) => {
      return {};
    });
}

function _getCurrentDemoAccoundId(templateInstagramUserId) {
  if (!templateInstagramUserId) {
    // origInstanceId = "84b14c71-cf23-4080-9f2b-a3d83e431012"
    if (origInstanceId && mapTemplatesAdi[origInstanceId])
      return mapTemplatesAdi[origInstanceId];
    if (WixService.isEditorX()) return defaultDemoAccountEditorX.id;
    else return defaultDemoAccount.id;
  } else {
    return templateInstagramUserId;
  }
}

const _getCurrentTokenError = (errorTokenType) => {
  switch (errorTokenType) {
    case 1:
      return 'Error validating access token: Sessions for the user are not allowed because the user is not a confirmed user.';
    case 2:
      return 'Error validating access token: The user has not authorized application 485795612358822.';
    case 3:
      return 'Error validating access token: The session has been invalidated because the user changed their password or Facebook has changed the session for security reasons.';
    case 4:
      return 'Application does not have permission for this action';
    default:
      return 'general';
  }
};

const _getDemoAccountMedias = (demoAccountId) => {
  // loading demo account from local json
  return getTemplateMedias(demoAccountId).then(({ medias, pagination }) => {
    const mediasObj = {};
    mediasObj.medias = medias;
    mediasObj.demoAccount = true;
    mediasObj.pagination = {};
    console.log('demoAccountData end', mediasObj);
    return mediasObj;
  });
};

const _getConnectionData = (data) => {
  const instaToken = data['in_access_token'] || data['insta_access_token'];
  const instaUserId = data['in_u_id'] || data['insta_user_id'];
  const templateInstagramUserId = data['template_in_u_id'];
  const isOldApi = !data['expires_in'];

  return { instaToken, instaUserId, templateInstagramUserId, isOldApi };
};

const getDefaultUserData = (templateInstagramUserId) => {
  const demoAccountId = _getCurrentDemoAccoundId(templateInstagramUserId);
  return getTemplateUser(demoAccountId);
};

const getUserInfo = () => {
  return _getInstagramData()
    .then((data) => {
      const {
        instaToken,
        instaUserId,
        templateInstagramUserId,
      } = _getConnectionData(data);

      if (data.errorTokenType) {
        getDefaultUserData(templateInstagramUserId);
      }
      if (!defaultInstaIds.includes(instaUserId) && instaToken && instaUserId) {
        return getInstagramUser();
      } else {
        // demo account
        let demoAccountId = _getCurrentDemoAccoundId(templateInstagramUserId);
        if (defaultInstaIds.includes(instaUserId)) demoAccountId = instaUserId;
        return getTemplateUser(demoAccountId);
      }
    })
    .catch((err) => err);
};

const getInstagramMediasData = (from, count) => {
  return _getInstagramData().then((data) => {
    const {
      instaToken,
      instaUserId,
      templateInstagramUserId,
      isOldApi,
    } = _getConnectionData(data);
    if (data.errorTokenType) {
      throw buildError(
        ERRORS.INVALID_TOKEN,
        _getCurrentTokenError(data.errorTokenType),
      );
      triggerEvent(biData.ACCESS_TOKEN_ERROR);
    }
    if (!defaultInstaIds.includes(instaUserId) && instaToken && instaUserId) {
      if (isOldApi) {
        throw buildError(ERRORS.OLD_API, 'instagarm connected with old api');
      } else return getInstagramMedias(from, count);
    } else {
      // loading demo account from local json
      let demoAccountId;
      if (defaultInstaIds.includes(instaUserId)) {
        demoAccountId = instaUserId;
      } else {
        demoAccountId = _getCurrentDemoAccoundId(templateInstagramUserId);
      }
      return _getDemoAccountMedias(demoAccountId, from, count);
    }
  });
};

export { getUserInfo, getInstagramMediasData };
